import Axios from "axios";

export const fetchRoadSpecialEventsStart = () => ({
  type: "FETCH_ROAD_SPECIAL_EVENTS_START"
});

export const fetchRoadSpecialEventsSuccess = (roadSpecialEvents) => ({
  type: "FETCH_ROAD_SPECIAL_EVENTS_SUCCESS",
  payload: roadSpecialEvents
});

export const fetchRoadSpecialEventsFailure = (error) => ({
  type: "FETCH_ROAD_SPECIAL_EVENTS_FAILURE",
  payload: error
});
export const saveRoadSpecialEventsStart = (roadSpecialEvents) => ({
  type: "SAVE_ROAD_SPECIAL_EVENTS_START",
  payload:roadSpecialEvents
});

export const saveRoadSpecialEventsSuccess = () => ({
  type: "SAVE_ROAD_SPECIAL_EVENTS_SUCCESS",
});

export const saveRoadSpecialEventsFailure = (error) => ({
  type: "SAVE_ROAD_SPECIAL_EVENTS_FAILURE",
  payload: error
});

